import { render, staticRenderFns } from "./TeamSurveyQuestionCreate.vue?vue&type=template&id=348aba8c&"
import script from "./TeamSurveyQuestionCreate.vue?vue&type=script&lang=js&"
export * from "./TeamSurveyQuestionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports